<div class="google__main mt-3" *ngIf="showButton">
   <button class="btn" type="button" (click)="signInWithFB()">
       <img src="../../../assets/images/logo-fb.svg" alt="">
       <span>Continue with Facebook</span>
   </button>
</div>
